import { EXERCISE_TYPE } from '../../constants'
import { getTypeExerciseUtil } from '../get-type'

function isWarmUpOrStretchingExerciseUtil (exercise) {
  const type = getTypeExerciseUtil(exercise)
  return [
    EXERCISE_TYPE.WARMUP,
    EXERCISE_TYPE.YOGA,
    EXERCISE_TYPE.SMR,
    EXERCISE_TYPE.BALANCE,
    EXERCISE_TYPE.ACTIVITY,
    EXERCISE_TYPE.STRETCHING
  ].includes(type)
}

export { isWarmUpOrStretchingExerciseUtil }
